import { View } from '@appstractdk/as-core';

class Header extends View {
	constructor(el, handler) {
		super(el);
		this.handler = handler;
		this.menuActive = false;

		[...this.el.querySelectorAll(".js-select")].forEach(dropdown => this.handler.initDropdown(dropdown, this, false, false));

		this.addListener("click", ".burger-menu-wrapper", this.onMenuToggle);
	}


	onMenuToggle() {
		if (this.el.classList.contains("menu-open")) {
			document.body.classList.remove("fixed");
			this.el.classList.remove("menu-open");
		} else {
			setTimeout(() => {
				this.el.classList.add("menu-open");
				document.body.classList.add("fixed");
			}, 100);
		}

		if (!this.menuActive) {
			this.el.classList.add("is-menu-open");
			this.el.classList.remove("is-menu-closed");
			setTimeout(() => {
				this.el.classList.add("has-fixed-inner-header");
			}, 200);
		} else {
			this.el.classList.remove("is-menu-open");
			this.el.classList.add("is-menu-closed");
			setTimeout(() => {
				this.el.classList.remove("has-fixed-inner-header");
			}, 300);
		}

		this.menuActive = !this.menuActive;

	}


	static init(handler, selector = ".header", base = document) {
		return [...base.querySelectorAll(selector)].map(node => new Header(node, handler));
	}

}

export default Header;
